/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as InspectionsRouteRouteImport } from './routes/inspections/route'
import { Route as AdminIdRouteRouteImport } from './routes/admin/$id/route'
import { Route as AuthConfirmPrivateEmailRouteImport } from './routes/auth/confirm-private-email'
import { Route as AuthConfirmWorkEmailRouteImport } from './routes/auth/confirm-work-email'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthRefreshRouteImport } from './routes/auth/refresh'
import { Route as AuthSsoCallbackRouteImport } from './routes/auth/sso-callback'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardSplatRouteImport } from './routes/dashboard/$'
import { Route as EmployeeIdRouteRouteImport } from './routes/employee/$id/route'
import { Route as InspectionsIndexRouteImport } from './routes/inspections/index'
import { Route as InspectionsIdRouteRouteImport } from './routes/inspections/$id/route'
import { Route as AdminIdIndexRouteImport } from './routes/admin/$id/index'
import { Route as AdminIdHeldPairsRouteImport } from './routes/admin/$id/held-pairs'
import { Route as AdminIdSettingsRouteImport } from './routes/admin/$id/settings'
import { Route as AdminAddClientClientIdRouteRouteImport } from './routes/admin/add-client/$clientId/route'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/auth/forgot-password/index'
import { Route as AuthForgotPasswordSetRouteImport } from './routes/auth/forgot-password/set'
import { Route as AuthForgotPasswordSuccessRouteImport } from './routes/auth/forgot-password/success'
import { Route as AuthRegisterIndexRouteImport } from './routes/auth/register/index'
import { Route as AuthRegisterDearestRouteImport } from './routes/auth/register/dearest'
import { Route as AuthRegisterInviteRouteImport } from './routes/auth/register/invite'
import { Route as ClientsClientIdDashboardRouteRouteImport } from './routes/clients/$clientId/dashboard/route'
import { Route as EmployeeUploadsUploadIdFailedRowsRouteImport } from './routes/employee-uploads/$uploadId/failed-rows'
import { Route as EmployeeIdIndexRouteImport } from './routes/employee/$id/index'
import { Route as EmployeeIdDocumentsRouteImport } from './routes/employee/$id/documents'
import { Route as EmployeeIdOnlineCoursesRouteImport } from './routes/employee/$id/online-courses'
import { Route as EmployeeIdSettingsRouteImport } from './routes/employee/$id/settings'
import { Route as InspectionsIdQuestionsRouteImport } from './routes/inspections/$id/questions'
import { Route as InspectionsIdSummaryRouteImport } from './routes/inspections/$id/summary'
import { Route as AdminAddClientClientIdCompanyInformationRouteImport } from './routes/admin/add-client/$clientId/company-information'
import { Route as AdminAddClientClientIdContractObligationsRouteImport } from './routes/admin/add-client/$clientId/contract-obligations'
import { Route as AdminAddClientClientIdLicensesRouteImport } from './routes/admin/add-client/$clientId/licenses'
import { Route as AdminAddClientClientIdLocationsRouteImport } from './routes/admin/add-client/$clientId/locations'
import { Route as AdminAddClientClientIdOnlineCoursesAndDocumentsRouteImport } from './routes/admin/add-client/$clientId/online-courses-and-documents'
import { Route as AdminAddClientClientIdRiskCenterRouteImport } from './routes/admin/add-client/$clientId/risk-center'
import { Route as AdminAddClientClientIdSuccessRouteImport } from './routes/admin/add-client/$clientId/success'
import { Route as AuthRegisterAddEmployeesIndexRouteImport } from './routes/auth/register/add-employees/index'
import { Route as AuthRegisterAddEmployeesErrorRouteImport } from './routes/auth/register/add-employees/error'
import { Route as AuthRegisterAddEmployeesPersonioRouteImport } from './routes/auth/register/add-employees/personio'
import { Route as AuthRegisterAddEmployeesSapRouteImport } from './routes/auth/register/add-employees/sap'
import { Route as AuthRegisterAddEmployeesSuccessRouteImport } from './routes/auth/register/add-employees/success'
import { Route as AuthRegisterAddEmployeesUploadRouteImport } from './routes/auth/register/add-employees/upload'
import { Route as AuthRegisterCodeIndexRouteImport } from './routes/auth/register/code/index'
import { Route as AuthRegisterCodeSuccessRouteImport } from './routes/auth/register/code/success'
import { Route as ClientsClientIdDashboardIndexRouteImport } from './routes/clients/$clientId/dashboard/index'
import { Route as ClientsClientIdDashboardEmployeeListRouteImport } from './routes/clients/$clientId/dashboard/employee-list'
import { Route as ClientsClientIdDashboardInsightsRouteImport } from './routes/clients/$clientId/dashboard/insights'
import { Route as ClientsClientIdDashboardMeasureCenterRouteImport } from './routes/clients/$clientId/dashboard/measure-center'
import { Route as ClientsClientIdDashboardPrecautionaryIndexRouteImport } from './routes/clients/$clientId/dashboard/precautionary-index'
import { Route as ClientsClientIdDashboardRiskCenterRouteImport } from './routes/clients/$clientId/dashboard/risk-center'
import { Route as ClientsClientIdDashboardSettingsRouteImport } from './routes/clients/$clientId/dashboard/settings'
import { Route as EmployeeIdDearestIndexRouteImport } from './routes/employee/$id/dearest/index'
import { Route as EmployeeIdDearestSessionsRouteImport } from './routes/employee/$id/dearest/sessions'
import { Route as ClientsClientIdDashboardDearestIndexRouteImport } from './routes/clients/$clientId/dashboard/dearest/index'
import { Route as ClientsClientIdDashboardDearestCoachesRouteImport } from './routes/clients/$clientId/dashboard/dearest/coaches'
import { Route as ClientsClientIdDashboardDearestSessionsRouteImport } from './routes/clients/$clientId/dashboard/dearest/sessions'
import { Route as ClientsClientIdDashboardDearestShareRouteImport } from './routes/clients/$clientId/dashboard/dearest/share'
import { Route as ClientsClientIdDashboardDocumentsIndexRouteImport } from './routes/clients/$clientId/dashboard/documents/index'
import { Route as ClientsClientIdDashboardDocumentsDocumentIdRouteImport } from './routes/clients/$clientId/dashboard/documents/$documentId'
import { Route as ClientsClientIdDashboardOnlineCoursesIndexRouteImport } from './routes/clients/$clientId/dashboard/online-courses/index'
import { Route as ClientsClientIdDashboardOnlineCoursesCourseIdRouteImport } from './routes/clients/$clientId/dashboard/online-courses/$courseId'
import { Route as EmployeeIdDearestBookIndexRouteImport } from './routes/employee/$id/dearest/book/index'
import { Route as EmployeeIdDearestBookExternalConfirmRouteImport } from './routes/employee/$id/dearest/book/external-confirm'
import { Route as ClientsClientIdDashboardDearestBookIndexRouteImport } from './routes/clients/$clientId/dashboard/dearest/book/index'
import { Route as ClientsClientIdDashboardDearestBookExternalConfirmRouteImport } from './routes/clients/$clientId/dashboard/dearest/book/external-confirm'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsRouteRoute = InspectionsRouteRouteImport.update({
  id: '/inspections',
  path: '/inspections',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIdRouteRoute = AdminIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AuthConfirmPrivateEmailRoute = AuthConfirmPrivateEmailRouteImport.update({
  id: '/confirm-private-email',
  path: '/confirm-private-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthConfirmWorkEmailRoute = AuthConfirmWorkEmailRouteImport.update({
  id: '/confirm-work-email',
  path: '/confirm-work-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRefreshRoute = AuthRefreshRouteImport.update({
  id: '/refresh',
  path: '/refresh',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSplatRoute = DashboardSplatRouteImport.update({
  id: '/dashboard/$',
  path: '/dashboard/$',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeIdRouteRoute = EmployeeIdRouteRouteImport.update({
  id: '/employee/$id',
  path: '/employee/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsIndexRoute = InspectionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InspectionsRouteRoute,
} as any)
const InspectionsIdRouteRoute = InspectionsIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => InspectionsRouteRoute,
} as any)
const AdminIdIndexRoute = AdminIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminIdRouteRoute,
} as any)
const AdminIdHeldPairsRoute = AdminIdHeldPairsRouteImport.update({
  id: '/held-pairs',
  path: '/held-pairs',
  getParentRoute: () => AdminIdRouteRoute,
} as any)
const AdminIdSettingsRoute = AdminIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminIdRouteRoute,
} as any)
const AdminAddClientClientIdRouteRoute =
  AdminAddClientClientIdRouteRouteImport.update({
    id: '/add-client/$clientId',
    path: '/add-client/$clientId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordSetRoute = AuthForgotPasswordSetRouteImport.update({
  id: '/forgot-password/set',
  path: '/forgot-password/set',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordSuccessRoute =
  AuthForgotPasswordSuccessRouteImport.update({
    id: '/forgot-password/success',
    path: '/forgot-password/success',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthRegisterIndexRoute = AuthRegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterDearestRoute = AuthRegisterDearestRouteImport.update({
  id: '/register/dearest',
  path: '/register/dearest',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterInviteRoute = AuthRegisterInviteRouteImport.update({
  id: '/register/invite',
  path: '/register/invite',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ClientsClientIdDashboardRouteRoute =
  ClientsClientIdDashboardRouteRouteImport.update({
    id: '/clients/$clientId/dashboard',
    path: '/clients/$clientId/dashboard',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmployeeUploadsUploadIdFailedRowsRoute =
  EmployeeUploadsUploadIdFailedRowsRouteImport.update({
    id: '/employee-uploads/$uploadId/failed-rows',
    path: '/employee-uploads/$uploadId/failed-rows',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmployeeIdIndexRoute = EmployeeIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EmployeeIdRouteRoute,
} as any)
const EmployeeIdDocumentsRoute = EmployeeIdDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => EmployeeIdRouteRoute,
} as any)
const EmployeeIdOnlineCoursesRoute = EmployeeIdOnlineCoursesRouteImport.update({
  id: '/online-courses',
  path: '/online-courses',
  getParentRoute: () => EmployeeIdRouteRoute,
} as any)
const EmployeeIdSettingsRoute = EmployeeIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => EmployeeIdRouteRoute,
} as any)
const InspectionsIdQuestionsRoute = InspectionsIdQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => InspectionsIdRouteRoute,
} as any)
const InspectionsIdSummaryRoute = InspectionsIdSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => InspectionsIdRouteRoute,
} as any)
const AdminAddClientClientIdCompanyInformationRoute =
  AdminAddClientClientIdCompanyInformationRouteImport.update({
    id: '/company-information',
    path: '/company-information',
    getParentRoute: () => AdminAddClientClientIdRouteRoute,
  } as any)
const AdminAddClientClientIdContractObligationsRoute =
  AdminAddClientClientIdContractObligationsRouteImport.update({
    id: '/contract-obligations',
    path: '/contract-obligations',
    getParentRoute: () => AdminAddClientClientIdRouteRoute,
  } as any)
const AdminAddClientClientIdLicensesRoute =
  AdminAddClientClientIdLicensesRouteImport.update({
    id: '/licenses',
    path: '/licenses',
    getParentRoute: () => AdminAddClientClientIdRouteRoute,
  } as any)
const AdminAddClientClientIdLocationsRoute =
  AdminAddClientClientIdLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AdminAddClientClientIdRouteRoute,
  } as any)
const AdminAddClientClientIdOnlineCoursesAndDocumentsRoute =
  AdminAddClientClientIdOnlineCoursesAndDocumentsRouteImport.update({
    id: '/online-courses-and-documents',
    path: '/online-courses-and-documents',
    getParentRoute: () => AdminAddClientClientIdRouteRoute,
  } as any)
const AdminAddClientClientIdRiskCenterRoute =
  AdminAddClientClientIdRiskCenterRouteImport.update({
    id: '/risk-center',
    path: '/risk-center',
    getParentRoute: () => AdminAddClientClientIdRouteRoute,
  } as any)
const AdminAddClientClientIdSuccessRoute =
  AdminAddClientClientIdSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AdminAddClientClientIdRouteRoute,
  } as any)
const AuthRegisterAddEmployeesIndexRoute =
  AuthRegisterAddEmployeesIndexRouteImport.update({
    id: '/register/add-employees/',
    path: '/register/add-employees/',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthRegisterAddEmployeesErrorRoute =
  AuthRegisterAddEmployeesErrorRouteImport.update({
    id: '/register/add-employees/error',
    path: '/register/add-employees/error',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthRegisterAddEmployeesPersonioRoute =
  AuthRegisterAddEmployeesPersonioRouteImport.update({
    id: '/register/add-employees/personio',
    path: '/register/add-employees/personio',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthRegisterAddEmployeesSapRoute =
  AuthRegisterAddEmployeesSapRouteImport.update({
    id: '/register/add-employees/sap',
    path: '/register/add-employees/sap',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthRegisterAddEmployeesSuccessRoute =
  AuthRegisterAddEmployeesSuccessRouteImport.update({
    id: '/register/add-employees/success',
    path: '/register/add-employees/success',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthRegisterAddEmployeesUploadRoute =
  AuthRegisterAddEmployeesUploadRouteImport.update({
    id: '/register/add-employees/upload',
    path: '/register/add-employees/upload',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthRegisterCodeIndexRoute = AuthRegisterCodeIndexRouteImport.update({
  id: '/register/code/',
  path: '/register/code/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterCodeSuccessRoute = AuthRegisterCodeSuccessRouteImport.update({
  id: '/register/code/success',
  path: '/register/code/success',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ClientsClientIdDashboardIndexRoute =
  ClientsClientIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardEmployeeListRoute =
  ClientsClientIdDashboardEmployeeListRouteImport.update({
    id: '/employee-list',
    path: '/employee-list',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardInsightsRoute =
  ClientsClientIdDashboardInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardMeasureCenterRoute =
  ClientsClientIdDashboardMeasureCenterRouteImport.update({
    id: '/measure-center',
    path: '/measure-center',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardPrecautionaryIndexRoute =
  ClientsClientIdDashboardPrecautionaryIndexRouteImport.update({
    id: '/precautionary-index',
    path: '/precautionary-index',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardRiskCenterRoute =
  ClientsClientIdDashboardRiskCenterRouteImport.update({
    id: '/risk-center',
    path: '/risk-center',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardSettingsRoute =
  ClientsClientIdDashboardSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const EmployeeIdDearestIndexRoute = EmployeeIdDearestIndexRouteImport.update({
  id: '/dearest/',
  path: '/dearest/',
  getParentRoute: () => EmployeeIdRouteRoute,
} as any)
const EmployeeIdDearestSessionsRoute =
  EmployeeIdDearestSessionsRouteImport.update({
    id: '/dearest/sessions',
    path: '/dearest/sessions',
    getParentRoute: () => EmployeeIdRouteRoute,
  } as any)
const ClientsClientIdDashboardDearestIndexRoute =
  ClientsClientIdDashboardDearestIndexRouteImport.update({
    id: '/dearest/',
    path: '/dearest/',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardDearestCoachesRoute =
  ClientsClientIdDashboardDearestCoachesRouteImport.update({
    id: '/dearest/coaches',
    path: '/dearest/coaches',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardDearestSessionsRoute =
  ClientsClientIdDashboardDearestSessionsRouteImport.update({
    id: '/dearest/sessions',
    path: '/dearest/sessions',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardDearestShareRoute =
  ClientsClientIdDashboardDearestShareRouteImport.update({
    id: '/dearest/share',
    path: '/dearest/share',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardDocumentsIndexRoute =
  ClientsClientIdDashboardDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardDocumentsDocumentIdRoute =
  ClientsClientIdDashboardDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardOnlineCoursesIndexRoute =
  ClientsClientIdDashboardOnlineCoursesIndexRouteImport.update({
    id: '/online-courses/',
    path: '/online-courses/',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardOnlineCoursesCourseIdRoute =
  ClientsClientIdDashboardOnlineCoursesCourseIdRouteImport.update({
    id: '/online-courses/$courseId',
    path: '/online-courses/$courseId',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const EmployeeIdDearestBookIndexRoute =
  EmployeeIdDearestBookIndexRouteImport.update({
    id: '/dearest/book/',
    path: '/dearest/book/',
    getParentRoute: () => EmployeeIdRouteRoute,
  } as any)
const EmployeeIdDearestBookExternalConfirmRoute =
  EmployeeIdDearestBookExternalConfirmRouteImport.update({
    id: '/dearest/book/external-confirm',
    path: '/dearest/book/external-confirm',
    getParentRoute: () => EmployeeIdRouteRoute,
  } as any)
const ClientsClientIdDashboardDearestBookIndexRoute =
  ClientsClientIdDashboardDearestBookIndexRouteImport.update({
    id: '/dearest/book/',
    path: '/dearest/book/',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)
const ClientsClientIdDashboardDearestBookExternalConfirmRoute =
  ClientsClientIdDashboardDearestBookExternalConfirmRouteImport.update({
    id: '/dearest/book/external-confirm',
    path: '/dearest/book/external-confirm',
    getParentRoute: () => ClientsClientIdDashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/inspections': typeof InspectionsRouteRouteWithChildren
  '/admin/$id': typeof AdminIdRouteRouteWithChildren
  '/employee/$id': typeof EmployeeIdRouteRouteWithChildren
  '/inspections/$id': typeof InspectionsIdRouteRouteWithChildren
  '/auth/confirm-private-email': typeof AuthConfirmPrivateEmailRoute
  '/auth/confirm-work-email': typeof AuthConfirmWorkEmailRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/refresh': typeof AuthRefreshRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/inspections/': typeof InspectionsIndexRoute
  '/admin/add-client/$clientId': typeof AdminAddClientClientIdRouteRouteWithChildren
  '/clients/$clientId/dashboard': typeof ClientsClientIdDashboardRouteRouteWithChildren
  '/admin/$id/held-pairs': typeof AdminIdHeldPairsRoute
  '/admin/$id/settings': typeof AdminIdSettingsRoute
  '/auth/forgot-password/set': typeof AuthForgotPasswordSetRoute
  '/auth/forgot-password/success': typeof AuthForgotPasswordSuccessRoute
  '/auth/register/dearest': typeof AuthRegisterDearestRoute
  '/auth/register/invite': typeof AuthRegisterInviteRoute
  '/employee-uploads/$uploadId/failed-rows': typeof EmployeeUploadsUploadIdFailedRowsRoute
  '/employee/$id/documents': typeof EmployeeIdDocumentsRoute
  '/employee/$id/online-courses': typeof EmployeeIdOnlineCoursesRoute
  '/employee/$id/settings': typeof EmployeeIdSettingsRoute
  '/inspections/$id/questions': typeof InspectionsIdQuestionsRoute
  '/inspections/$id/summary': typeof InspectionsIdSummaryRoute
  '/admin/$id/': typeof AdminIdIndexRoute
  '/auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/auth/register/': typeof AuthRegisterIndexRoute
  '/employee/$id/': typeof EmployeeIdIndexRoute
  '/admin/add-client/$clientId/company-information': typeof AdminAddClientClientIdCompanyInformationRoute
  '/admin/add-client/$clientId/contract-obligations': typeof AdminAddClientClientIdContractObligationsRoute
  '/admin/add-client/$clientId/licenses': typeof AdminAddClientClientIdLicensesRoute
  '/admin/add-client/$clientId/locations': typeof AdminAddClientClientIdLocationsRoute
  '/admin/add-client/$clientId/online-courses-and-documents': typeof AdminAddClientClientIdOnlineCoursesAndDocumentsRoute
  '/admin/add-client/$clientId/risk-center': typeof AdminAddClientClientIdRiskCenterRoute
  '/admin/add-client/$clientId/success': typeof AdminAddClientClientIdSuccessRoute
  '/auth/register/add-employees/error': typeof AuthRegisterAddEmployeesErrorRoute
  '/auth/register/add-employees/personio': typeof AuthRegisterAddEmployeesPersonioRoute
  '/auth/register/add-employees/sap': typeof AuthRegisterAddEmployeesSapRoute
  '/auth/register/add-employees/success': typeof AuthRegisterAddEmployeesSuccessRoute
  '/auth/register/add-employees/upload': typeof AuthRegisterAddEmployeesUploadRoute
  '/auth/register/code/success': typeof AuthRegisterCodeSuccessRoute
  '/clients/$clientId/dashboard/employee-list': typeof ClientsClientIdDashboardEmployeeListRoute
  '/clients/$clientId/dashboard/insights': typeof ClientsClientIdDashboardInsightsRoute
  '/clients/$clientId/dashboard/measure-center': typeof ClientsClientIdDashboardMeasureCenterRoute
  '/clients/$clientId/dashboard/precautionary-index': typeof ClientsClientIdDashboardPrecautionaryIndexRoute
  '/clients/$clientId/dashboard/risk-center': typeof ClientsClientIdDashboardRiskCenterRoute
  '/clients/$clientId/dashboard/settings': typeof ClientsClientIdDashboardSettingsRoute
  '/employee/$id/dearest/sessions': typeof EmployeeIdDearestSessionsRoute
  '/auth/register/add-employees/': typeof AuthRegisterAddEmployeesIndexRoute
  '/auth/register/code/': typeof AuthRegisterCodeIndexRoute
  '/clients/$clientId/dashboard/': typeof ClientsClientIdDashboardIndexRoute
  '/employee/$id/dearest/': typeof EmployeeIdDearestIndexRoute
  '/clients/$clientId/dashboard/dearest/coaches': typeof ClientsClientIdDashboardDearestCoachesRoute
  '/clients/$clientId/dashboard/dearest/sessions': typeof ClientsClientIdDashboardDearestSessionsRoute
  '/clients/$clientId/dashboard/dearest/share': typeof ClientsClientIdDashboardDearestShareRoute
  '/clients/$clientId/dashboard/documents/$documentId': typeof ClientsClientIdDashboardDocumentsDocumentIdRoute
  '/clients/$clientId/dashboard/online-courses/$courseId': typeof ClientsClientIdDashboardOnlineCoursesCourseIdRoute
  '/employee/$id/dearest/book/external-confirm': typeof EmployeeIdDearestBookExternalConfirmRoute
  '/clients/$clientId/dashboard/dearest/': typeof ClientsClientIdDashboardDearestIndexRoute
  '/clients/$clientId/dashboard/documents/': typeof ClientsClientIdDashboardDocumentsIndexRoute
  '/clients/$clientId/dashboard/online-courses/': typeof ClientsClientIdDashboardOnlineCoursesIndexRoute
  '/employee/$id/dearest/book/': typeof EmployeeIdDearestBookIndexRoute
  '/clients/$clientId/dashboard/dearest/book/external-confirm': typeof ClientsClientIdDashboardDearestBookExternalConfirmRoute
  '/clients/$clientId/dashboard/dearest/book/': typeof ClientsClientIdDashboardDearestBookIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/inspections/$id': typeof InspectionsIdRouteRouteWithChildren
  '/auth/confirm-private-email': typeof AuthConfirmPrivateEmailRoute
  '/auth/confirm-work-email': typeof AuthConfirmWorkEmailRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/refresh': typeof AuthRefreshRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/dashboard': typeof DashboardIndexRoute
  '/inspections': typeof InspectionsIndexRoute
  '/admin/add-client/$clientId': typeof AdminAddClientClientIdRouteRouteWithChildren
  '/admin/$id/held-pairs': typeof AdminIdHeldPairsRoute
  '/admin/$id/settings': typeof AdminIdSettingsRoute
  '/auth/forgot-password/set': typeof AuthForgotPasswordSetRoute
  '/auth/forgot-password/success': typeof AuthForgotPasswordSuccessRoute
  '/auth/register/dearest': typeof AuthRegisterDearestRoute
  '/auth/register/invite': typeof AuthRegisterInviteRoute
  '/employee-uploads/$uploadId/failed-rows': typeof EmployeeUploadsUploadIdFailedRowsRoute
  '/employee/$id/documents': typeof EmployeeIdDocumentsRoute
  '/employee/$id/online-courses': typeof EmployeeIdOnlineCoursesRoute
  '/employee/$id/settings': typeof EmployeeIdSettingsRoute
  '/inspections/$id/questions': typeof InspectionsIdQuestionsRoute
  '/inspections/$id/summary': typeof InspectionsIdSummaryRoute
  '/admin/$id': typeof AdminIdIndexRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/register': typeof AuthRegisterIndexRoute
  '/employee/$id': typeof EmployeeIdIndexRoute
  '/admin/add-client/$clientId/company-information': typeof AdminAddClientClientIdCompanyInformationRoute
  '/admin/add-client/$clientId/contract-obligations': typeof AdminAddClientClientIdContractObligationsRoute
  '/admin/add-client/$clientId/licenses': typeof AdminAddClientClientIdLicensesRoute
  '/admin/add-client/$clientId/locations': typeof AdminAddClientClientIdLocationsRoute
  '/admin/add-client/$clientId/online-courses-and-documents': typeof AdminAddClientClientIdOnlineCoursesAndDocumentsRoute
  '/admin/add-client/$clientId/risk-center': typeof AdminAddClientClientIdRiskCenterRoute
  '/admin/add-client/$clientId/success': typeof AdminAddClientClientIdSuccessRoute
  '/auth/register/add-employees/error': typeof AuthRegisterAddEmployeesErrorRoute
  '/auth/register/add-employees/personio': typeof AuthRegisterAddEmployeesPersonioRoute
  '/auth/register/add-employees/sap': typeof AuthRegisterAddEmployeesSapRoute
  '/auth/register/add-employees/success': typeof AuthRegisterAddEmployeesSuccessRoute
  '/auth/register/add-employees/upload': typeof AuthRegisterAddEmployeesUploadRoute
  '/auth/register/code/success': typeof AuthRegisterCodeSuccessRoute
  '/clients/$clientId/dashboard/employee-list': typeof ClientsClientIdDashboardEmployeeListRoute
  '/clients/$clientId/dashboard/insights': typeof ClientsClientIdDashboardInsightsRoute
  '/clients/$clientId/dashboard/measure-center': typeof ClientsClientIdDashboardMeasureCenterRoute
  '/clients/$clientId/dashboard/precautionary-index': typeof ClientsClientIdDashboardPrecautionaryIndexRoute
  '/clients/$clientId/dashboard/risk-center': typeof ClientsClientIdDashboardRiskCenterRoute
  '/clients/$clientId/dashboard/settings': typeof ClientsClientIdDashboardSettingsRoute
  '/employee/$id/dearest/sessions': typeof EmployeeIdDearestSessionsRoute
  '/auth/register/add-employees': typeof AuthRegisterAddEmployeesIndexRoute
  '/auth/register/code': typeof AuthRegisterCodeIndexRoute
  '/clients/$clientId/dashboard': typeof ClientsClientIdDashboardIndexRoute
  '/employee/$id/dearest': typeof EmployeeIdDearestIndexRoute
  '/clients/$clientId/dashboard/dearest/coaches': typeof ClientsClientIdDashboardDearestCoachesRoute
  '/clients/$clientId/dashboard/dearest/sessions': typeof ClientsClientIdDashboardDearestSessionsRoute
  '/clients/$clientId/dashboard/dearest/share': typeof ClientsClientIdDashboardDearestShareRoute
  '/clients/$clientId/dashboard/documents/$documentId': typeof ClientsClientIdDashboardDocumentsDocumentIdRoute
  '/clients/$clientId/dashboard/online-courses/$courseId': typeof ClientsClientIdDashboardOnlineCoursesCourseIdRoute
  '/employee/$id/dearest/book/external-confirm': typeof EmployeeIdDearestBookExternalConfirmRoute
  '/clients/$clientId/dashboard/dearest': typeof ClientsClientIdDashboardDearestIndexRoute
  '/clients/$clientId/dashboard/documents': typeof ClientsClientIdDashboardDocumentsIndexRoute
  '/clients/$clientId/dashboard/online-courses': typeof ClientsClientIdDashboardOnlineCoursesIndexRoute
  '/employee/$id/dearest/book': typeof EmployeeIdDearestBookIndexRoute
  '/clients/$clientId/dashboard/dearest/book/external-confirm': typeof ClientsClientIdDashboardDearestBookExternalConfirmRoute
  '/clients/$clientId/dashboard/dearest/book': typeof ClientsClientIdDashboardDearestBookIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/inspections': typeof InspectionsRouteRouteWithChildren
  '/admin/$id': typeof AdminIdRouteRouteWithChildren
  '/employee/$id': typeof EmployeeIdRouteRouteWithChildren
  '/inspections/$id': typeof InspectionsIdRouteRouteWithChildren
  '/auth/confirm-private-email': typeof AuthConfirmPrivateEmailRoute
  '/auth/confirm-work-email': typeof AuthConfirmWorkEmailRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/refresh': typeof AuthRefreshRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/inspections/': typeof InspectionsIndexRoute
  '/admin/add-client/$clientId': typeof AdminAddClientClientIdRouteRouteWithChildren
  '/clients/$clientId/dashboard': typeof ClientsClientIdDashboardRouteRouteWithChildren
  '/admin/$id/held-pairs': typeof AdminIdHeldPairsRoute
  '/admin/$id/settings': typeof AdminIdSettingsRoute
  '/auth/forgot-password/set': typeof AuthForgotPasswordSetRoute
  '/auth/forgot-password/success': typeof AuthForgotPasswordSuccessRoute
  '/auth/register/dearest': typeof AuthRegisterDearestRoute
  '/auth/register/invite': typeof AuthRegisterInviteRoute
  '/employee-uploads/$uploadId/failed-rows': typeof EmployeeUploadsUploadIdFailedRowsRoute
  '/employee/$id/documents': typeof EmployeeIdDocumentsRoute
  '/employee/$id/online-courses': typeof EmployeeIdOnlineCoursesRoute
  '/employee/$id/settings': typeof EmployeeIdSettingsRoute
  '/inspections/$id/questions': typeof InspectionsIdQuestionsRoute
  '/inspections/$id/summary': typeof InspectionsIdSummaryRoute
  '/admin/$id/': typeof AdminIdIndexRoute
  '/auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/auth/register/': typeof AuthRegisterIndexRoute
  '/employee/$id/': typeof EmployeeIdIndexRoute
  '/admin/add-client/$clientId/company-information': typeof AdminAddClientClientIdCompanyInformationRoute
  '/admin/add-client/$clientId/contract-obligations': typeof AdminAddClientClientIdContractObligationsRoute
  '/admin/add-client/$clientId/licenses': typeof AdminAddClientClientIdLicensesRoute
  '/admin/add-client/$clientId/locations': typeof AdminAddClientClientIdLocationsRoute
  '/admin/add-client/$clientId/online-courses-and-documents': typeof AdminAddClientClientIdOnlineCoursesAndDocumentsRoute
  '/admin/add-client/$clientId/risk-center': typeof AdminAddClientClientIdRiskCenterRoute
  '/admin/add-client/$clientId/success': typeof AdminAddClientClientIdSuccessRoute
  '/auth/register/add-employees/error': typeof AuthRegisterAddEmployeesErrorRoute
  '/auth/register/add-employees/personio': typeof AuthRegisterAddEmployeesPersonioRoute
  '/auth/register/add-employees/sap': typeof AuthRegisterAddEmployeesSapRoute
  '/auth/register/add-employees/success': typeof AuthRegisterAddEmployeesSuccessRoute
  '/auth/register/add-employees/upload': typeof AuthRegisterAddEmployeesUploadRoute
  '/auth/register/code/success': typeof AuthRegisterCodeSuccessRoute
  '/clients/$clientId/dashboard/employee-list': typeof ClientsClientIdDashboardEmployeeListRoute
  '/clients/$clientId/dashboard/insights': typeof ClientsClientIdDashboardInsightsRoute
  '/clients/$clientId/dashboard/measure-center': typeof ClientsClientIdDashboardMeasureCenterRoute
  '/clients/$clientId/dashboard/precautionary-index': typeof ClientsClientIdDashboardPrecautionaryIndexRoute
  '/clients/$clientId/dashboard/risk-center': typeof ClientsClientIdDashboardRiskCenterRoute
  '/clients/$clientId/dashboard/settings': typeof ClientsClientIdDashboardSettingsRoute
  '/employee/$id/dearest/sessions': typeof EmployeeIdDearestSessionsRoute
  '/auth/register/add-employees/': typeof AuthRegisterAddEmployeesIndexRoute
  '/auth/register/code/': typeof AuthRegisterCodeIndexRoute
  '/clients/$clientId/dashboard/': typeof ClientsClientIdDashboardIndexRoute
  '/employee/$id/dearest/': typeof EmployeeIdDearestIndexRoute
  '/clients/$clientId/dashboard/dearest/coaches': typeof ClientsClientIdDashboardDearestCoachesRoute
  '/clients/$clientId/dashboard/dearest/sessions': typeof ClientsClientIdDashboardDearestSessionsRoute
  '/clients/$clientId/dashboard/dearest/share': typeof ClientsClientIdDashboardDearestShareRoute
  '/clients/$clientId/dashboard/documents/$documentId': typeof ClientsClientIdDashboardDocumentsDocumentIdRoute
  '/clients/$clientId/dashboard/online-courses/$courseId': typeof ClientsClientIdDashboardOnlineCoursesCourseIdRoute
  '/employee/$id/dearest/book/external-confirm': typeof EmployeeIdDearestBookExternalConfirmRoute
  '/clients/$clientId/dashboard/dearest/': typeof ClientsClientIdDashboardDearestIndexRoute
  '/clients/$clientId/dashboard/documents/': typeof ClientsClientIdDashboardDocumentsIndexRoute
  '/clients/$clientId/dashboard/online-courses/': typeof ClientsClientIdDashboardOnlineCoursesIndexRoute
  '/employee/$id/dearest/book/': typeof EmployeeIdDearestBookIndexRoute
  '/clients/$clientId/dashboard/dearest/book/external-confirm': typeof ClientsClientIdDashboardDearestBookExternalConfirmRoute
  '/clients/$clientId/dashboard/dearest/book/': typeof ClientsClientIdDashboardDearestBookIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/auth'
    | '/inspections'
    | '/admin/$id'
    | '/employee/$id'
    | '/inspections/$id'
    | '/auth/confirm-private-email'
    | '/auth/confirm-work-email'
    | '/auth/login'
    | '/auth/refresh'
    | '/auth/sso-callback'
    | '/dashboard/$'
    | '/dashboard/'
    | '/inspections/'
    | '/admin/add-client/$clientId'
    | '/clients/$clientId/dashboard'
    | '/admin/$id/held-pairs'
    | '/admin/$id/settings'
    | '/auth/forgot-password/set'
    | '/auth/forgot-password/success'
    | '/auth/register/dearest'
    | '/auth/register/invite'
    | '/employee-uploads/$uploadId/failed-rows'
    | '/employee/$id/documents'
    | '/employee/$id/online-courses'
    | '/employee/$id/settings'
    | '/inspections/$id/questions'
    | '/inspections/$id/summary'
    | '/admin/$id/'
    | '/auth/forgot-password/'
    | '/auth/register/'
    | '/employee/$id/'
    | '/admin/add-client/$clientId/company-information'
    | '/admin/add-client/$clientId/contract-obligations'
    | '/admin/add-client/$clientId/licenses'
    | '/admin/add-client/$clientId/locations'
    | '/admin/add-client/$clientId/online-courses-and-documents'
    | '/admin/add-client/$clientId/risk-center'
    | '/admin/add-client/$clientId/success'
    | '/auth/register/add-employees/error'
    | '/auth/register/add-employees/personio'
    | '/auth/register/add-employees/sap'
    | '/auth/register/add-employees/success'
    | '/auth/register/add-employees/upload'
    | '/auth/register/code/success'
    | '/clients/$clientId/dashboard/employee-list'
    | '/clients/$clientId/dashboard/insights'
    | '/clients/$clientId/dashboard/measure-center'
    | '/clients/$clientId/dashboard/precautionary-index'
    | '/clients/$clientId/dashboard/risk-center'
    | '/clients/$clientId/dashboard/settings'
    | '/employee/$id/dearest/sessions'
    | '/auth/register/add-employees/'
    | '/auth/register/code/'
    | '/clients/$clientId/dashboard/'
    | '/employee/$id/dearest/'
    | '/clients/$clientId/dashboard/dearest/coaches'
    | '/clients/$clientId/dashboard/dearest/sessions'
    | '/clients/$clientId/dashboard/dearest/share'
    | '/clients/$clientId/dashboard/documents/$documentId'
    | '/clients/$clientId/dashboard/online-courses/$courseId'
    | '/employee/$id/dearest/book/external-confirm'
    | '/clients/$clientId/dashboard/dearest/'
    | '/clients/$clientId/dashboard/documents/'
    | '/clients/$clientId/dashboard/online-courses/'
    | '/employee/$id/dearest/book/'
    | '/clients/$clientId/dashboard/dearest/book/external-confirm'
    | '/clients/$clientId/dashboard/dearest/book/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/auth'
    | '/inspections/$id'
    | '/auth/confirm-private-email'
    | '/auth/confirm-work-email'
    | '/auth/login'
    | '/auth/refresh'
    | '/auth/sso-callback'
    | '/dashboard/$'
    | '/dashboard'
    | '/inspections'
    | '/admin/add-client/$clientId'
    | '/admin/$id/held-pairs'
    | '/admin/$id/settings'
    | '/auth/forgot-password/set'
    | '/auth/forgot-password/success'
    | '/auth/register/dearest'
    | '/auth/register/invite'
    | '/employee-uploads/$uploadId/failed-rows'
    | '/employee/$id/documents'
    | '/employee/$id/online-courses'
    | '/employee/$id/settings'
    | '/inspections/$id/questions'
    | '/inspections/$id/summary'
    | '/admin/$id'
    | '/auth/forgot-password'
    | '/auth/register'
    | '/employee/$id'
    | '/admin/add-client/$clientId/company-information'
    | '/admin/add-client/$clientId/contract-obligations'
    | '/admin/add-client/$clientId/licenses'
    | '/admin/add-client/$clientId/locations'
    | '/admin/add-client/$clientId/online-courses-and-documents'
    | '/admin/add-client/$clientId/risk-center'
    | '/admin/add-client/$clientId/success'
    | '/auth/register/add-employees/error'
    | '/auth/register/add-employees/personio'
    | '/auth/register/add-employees/sap'
    | '/auth/register/add-employees/success'
    | '/auth/register/add-employees/upload'
    | '/auth/register/code/success'
    | '/clients/$clientId/dashboard/employee-list'
    | '/clients/$clientId/dashboard/insights'
    | '/clients/$clientId/dashboard/measure-center'
    | '/clients/$clientId/dashboard/precautionary-index'
    | '/clients/$clientId/dashboard/risk-center'
    | '/clients/$clientId/dashboard/settings'
    | '/employee/$id/dearest/sessions'
    | '/auth/register/add-employees'
    | '/auth/register/code'
    | '/clients/$clientId/dashboard'
    | '/employee/$id/dearest'
    | '/clients/$clientId/dashboard/dearest/coaches'
    | '/clients/$clientId/dashboard/dearest/sessions'
    | '/clients/$clientId/dashboard/dearest/share'
    | '/clients/$clientId/dashboard/documents/$documentId'
    | '/clients/$clientId/dashboard/online-courses/$courseId'
    | '/employee/$id/dearest/book/external-confirm'
    | '/clients/$clientId/dashboard/dearest'
    | '/clients/$clientId/dashboard/documents'
    | '/clients/$clientId/dashboard/online-courses'
    | '/employee/$id/dearest/book'
    | '/clients/$clientId/dashboard/dearest/book/external-confirm'
    | '/clients/$clientId/dashboard/dearest/book'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/auth'
    | '/inspections'
    | '/admin/$id'
    | '/employee/$id'
    | '/inspections/$id'
    | '/auth/confirm-private-email'
    | '/auth/confirm-work-email'
    | '/auth/login'
    | '/auth/refresh'
    | '/auth/sso-callback'
    | '/dashboard/$'
    | '/dashboard/'
    | '/inspections/'
    | '/admin/add-client/$clientId'
    | '/clients/$clientId/dashboard'
    | '/admin/$id/held-pairs'
    | '/admin/$id/settings'
    | '/auth/forgot-password/set'
    | '/auth/forgot-password/success'
    | '/auth/register/dearest'
    | '/auth/register/invite'
    | '/employee-uploads/$uploadId/failed-rows'
    | '/employee/$id/documents'
    | '/employee/$id/online-courses'
    | '/employee/$id/settings'
    | '/inspections/$id/questions'
    | '/inspections/$id/summary'
    | '/admin/$id/'
    | '/auth/forgot-password/'
    | '/auth/register/'
    | '/employee/$id/'
    | '/admin/add-client/$clientId/company-information'
    | '/admin/add-client/$clientId/contract-obligations'
    | '/admin/add-client/$clientId/licenses'
    | '/admin/add-client/$clientId/locations'
    | '/admin/add-client/$clientId/online-courses-and-documents'
    | '/admin/add-client/$clientId/risk-center'
    | '/admin/add-client/$clientId/success'
    | '/auth/register/add-employees/error'
    | '/auth/register/add-employees/personio'
    | '/auth/register/add-employees/sap'
    | '/auth/register/add-employees/success'
    | '/auth/register/add-employees/upload'
    | '/auth/register/code/success'
    | '/clients/$clientId/dashboard/employee-list'
    | '/clients/$clientId/dashboard/insights'
    | '/clients/$clientId/dashboard/measure-center'
    | '/clients/$clientId/dashboard/precautionary-index'
    | '/clients/$clientId/dashboard/risk-center'
    | '/clients/$clientId/dashboard/settings'
    | '/employee/$id/dearest/sessions'
    | '/auth/register/add-employees/'
    | '/auth/register/code/'
    | '/clients/$clientId/dashboard/'
    | '/employee/$id/dearest/'
    | '/clients/$clientId/dashboard/dearest/coaches'
    | '/clients/$clientId/dashboard/dearest/sessions'
    | '/clients/$clientId/dashboard/dearest/share'
    | '/clients/$clientId/dashboard/documents/$documentId'
    | '/clients/$clientId/dashboard/online-courses/$courseId'
    | '/employee/$id/dearest/book/external-confirm'
    | '/clients/$clientId/dashboard/dearest/'
    | '/clients/$clientId/dashboard/documents/'
    | '/clients/$clientId/dashboard/online-courses/'
    | '/employee/$id/dearest/book/'
    | '/clients/$clientId/dashboard/dearest/book/external-confirm'
    | '/clients/$clientId/dashboard/dearest/book/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  InspectionsRouteRoute: typeof InspectionsRouteRouteWithChildren
  EmployeeIdRouteRoute: typeof EmployeeIdRouteRouteWithChildren
  DashboardSplatRoute: typeof DashboardSplatRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  ClientsClientIdDashboardRouteRoute: typeof ClientsClientIdDashboardRouteRouteWithChildren
  EmployeeUploadsUploadIdFailedRowsRoute: typeof EmployeeUploadsUploadIdFailedRowsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections': {
      id: '/inspections'
      path: '/inspections'
      fullPath: '/inspections'
      preLoaderRoute: typeof InspectionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$id': {
      id: '/admin/$id'
      path: '/$id'
      fullPath: '/admin/$id'
      preLoaderRoute: typeof AdminIdRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/auth/confirm-private-email': {
      id: '/auth/confirm-private-email'
      path: '/confirm-private-email'
      fullPath: '/auth/confirm-private-email'
      preLoaderRoute: typeof AuthConfirmPrivateEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/confirm-work-email': {
      id: '/auth/confirm-work-email'
      path: '/confirm-work-email'
      fullPath: '/auth/confirm-work-email'
      preLoaderRoute: typeof AuthConfirmWorkEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/refresh': {
      id: '/auth/refresh'
      path: '/refresh'
      fullPath: '/auth/refresh'
      preLoaderRoute: typeof AuthRefreshRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/sso-callback': {
      id: '/auth/sso-callback'
      path: '/sso-callback'
      fullPath: '/auth/sso-callback'
      preLoaderRoute: typeof AuthSsoCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$': {
      id: '/dashboard/$'
      path: '/dashboard/$'
      fullPath: '/dashboard/$'
      preLoaderRoute: typeof DashboardSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/$id': {
      id: '/employee/$id'
      path: '/employee/$id'
      fullPath: '/employee/$id'
      preLoaderRoute: typeof EmployeeIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections/': {
      id: '/inspections/'
      path: '/'
      fullPath: '/inspections/'
      preLoaderRoute: typeof InspectionsIndexRouteImport
      parentRoute: typeof InspectionsRouteRoute
    }
    '/inspections/$id': {
      id: '/inspections/$id'
      path: '/$id'
      fullPath: '/inspections/$id'
      preLoaderRoute: typeof InspectionsIdRouteRouteImport
      parentRoute: typeof InspectionsRouteRoute
    }
    '/admin/$id/': {
      id: '/admin/$id/'
      path: '/'
      fullPath: '/admin/$id/'
      preLoaderRoute: typeof AdminIdIndexRouteImport
      parentRoute: typeof AdminIdRouteRoute
    }
    '/admin/$id/held-pairs': {
      id: '/admin/$id/held-pairs'
      path: '/held-pairs'
      fullPath: '/admin/$id/held-pairs'
      preLoaderRoute: typeof AdminIdHeldPairsRouteImport
      parentRoute: typeof AdminIdRouteRoute
    }
    '/admin/$id/settings': {
      id: '/admin/$id/settings'
      path: '/settings'
      fullPath: '/admin/$id/settings'
      preLoaderRoute: typeof AdminIdSettingsRouteImport
      parentRoute: typeof AdminIdRouteRoute
    }
    '/admin/add-client/$clientId': {
      id: '/admin/add-client/$clientId'
      path: '/add-client/$clientId'
      fullPath: '/admin/add-client/$clientId'
      preLoaderRoute: typeof AdminAddClientClientIdRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/auth/forgot-password/': {
      id: '/auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password/'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forgot-password/set': {
      id: '/auth/forgot-password/set'
      path: '/forgot-password/set'
      fullPath: '/auth/forgot-password/set'
      preLoaderRoute: typeof AuthForgotPasswordSetRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forgot-password/success': {
      id: '/auth/forgot-password/success'
      path: '/forgot-password/success'
      fullPath: '/auth/forgot-password/success'
      preLoaderRoute: typeof AuthForgotPasswordSuccessRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/': {
      id: '/auth/register/'
      path: '/register'
      fullPath: '/auth/register/'
      preLoaderRoute: typeof AuthRegisterIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/dearest': {
      id: '/auth/register/dearest'
      path: '/register/dearest'
      fullPath: '/auth/register/dearest'
      preLoaderRoute: typeof AuthRegisterDearestRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/invite': {
      id: '/auth/register/invite'
      path: '/register/invite'
      fullPath: '/auth/register/invite'
      preLoaderRoute: typeof AuthRegisterInviteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/clients/$clientId/dashboard': {
      id: '/clients/$clientId/dashboard'
      path: '/clients/$clientId/dashboard'
      fullPath: '/clients/$clientId/dashboard'
      preLoaderRoute: typeof ClientsClientIdDashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee-uploads/$uploadId/failed-rows': {
      id: '/employee-uploads/$uploadId/failed-rows'
      path: '/employee-uploads/$uploadId/failed-rows'
      fullPath: '/employee-uploads/$uploadId/failed-rows'
      preLoaderRoute: typeof EmployeeUploadsUploadIdFailedRowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/$id/': {
      id: '/employee/$id/'
      path: '/'
      fullPath: '/employee/$id/'
      preLoaderRoute: typeof EmployeeIdIndexRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/employee/$id/documents': {
      id: '/employee/$id/documents'
      path: '/documents'
      fullPath: '/employee/$id/documents'
      preLoaderRoute: typeof EmployeeIdDocumentsRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/employee/$id/online-courses': {
      id: '/employee/$id/online-courses'
      path: '/online-courses'
      fullPath: '/employee/$id/online-courses'
      preLoaderRoute: typeof EmployeeIdOnlineCoursesRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/employee/$id/settings': {
      id: '/employee/$id/settings'
      path: '/settings'
      fullPath: '/employee/$id/settings'
      preLoaderRoute: typeof EmployeeIdSettingsRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/inspections/$id/questions': {
      id: '/inspections/$id/questions'
      path: '/questions'
      fullPath: '/inspections/$id/questions'
      preLoaderRoute: typeof InspectionsIdQuestionsRouteImport
      parentRoute: typeof InspectionsIdRouteRoute
    }
    '/inspections/$id/summary': {
      id: '/inspections/$id/summary'
      path: '/summary'
      fullPath: '/inspections/$id/summary'
      preLoaderRoute: typeof InspectionsIdSummaryRouteImport
      parentRoute: typeof InspectionsIdRouteRoute
    }
    '/admin/add-client/$clientId/company-information': {
      id: '/admin/add-client/$clientId/company-information'
      path: '/company-information'
      fullPath: '/admin/add-client/$clientId/company-information'
      preLoaderRoute: typeof AdminAddClientClientIdCompanyInformationRouteImport
      parentRoute: typeof AdminAddClientClientIdRouteRoute
    }
    '/admin/add-client/$clientId/contract-obligations': {
      id: '/admin/add-client/$clientId/contract-obligations'
      path: '/contract-obligations'
      fullPath: '/admin/add-client/$clientId/contract-obligations'
      preLoaderRoute: typeof AdminAddClientClientIdContractObligationsRouteImport
      parentRoute: typeof AdminAddClientClientIdRouteRoute
    }
    '/admin/add-client/$clientId/licenses': {
      id: '/admin/add-client/$clientId/licenses'
      path: '/licenses'
      fullPath: '/admin/add-client/$clientId/licenses'
      preLoaderRoute: typeof AdminAddClientClientIdLicensesRouteImport
      parentRoute: typeof AdminAddClientClientIdRouteRoute
    }
    '/admin/add-client/$clientId/locations': {
      id: '/admin/add-client/$clientId/locations'
      path: '/locations'
      fullPath: '/admin/add-client/$clientId/locations'
      preLoaderRoute: typeof AdminAddClientClientIdLocationsRouteImport
      parentRoute: typeof AdminAddClientClientIdRouteRoute
    }
    '/admin/add-client/$clientId/online-courses-and-documents': {
      id: '/admin/add-client/$clientId/online-courses-and-documents'
      path: '/online-courses-and-documents'
      fullPath: '/admin/add-client/$clientId/online-courses-and-documents'
      preLoaderRoute: typeof AdminAddClientClientIdOnlineCoursesAndDocumentsRouteImport
      parentRoute: typeof AdminAddClientClientIdRouteRoute
    }
    '/admin/add-client/$clientId/risk-center': {
      id: '/admin/add-client/$clientId/risk-center'
      path: '/risk-center'
      fullPath: '/admin/add-client/$clientId/risk-center'
      preLoaderRoute: typeof AdminAddClientClientIdRiskCenterRouteImport
      parentRoute: typeof AdminAddClientClientIdRouteRoute
    }
    '/admin/add-client/$clientId/success': {
      id: '/admin/add-client/$clientId/success'
      path: '/success'
      fullPath: '/admin/add-client/$clientId/success'
      preLoaderRoute: typeof AdminAddClientClientIdSuccessRouteImport
      parentRoute: typeof AdminAddClientClientIdRouteRoute
    }
    '/auth/register/add-employees/': {
      id: '/auth/register/add-employees/'
      path: '/register/add-employees'
      fullPath: '/auth/register/add-employees/'
      preLoaderRoute: typeof AuthRegisterAddEmployeesIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/add-employees/error': {
      id: '/auth/register/add-employees/error'
      path: '/register/add-employees/error'
      fullPath: '/auth/register/add-employees/error'
      preLoaderRoute: typeof AuthRegisterAddEmployeesErrorRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/add-employees/personio': {
      id: '/auth/register/add-employees/personio'
      path: '/register/add-employees/personio'
      fullPath: '/auth/register/add-employees/personio'
      preLoaderRoute: typeof AuthRegisterAddEmployeesPersonioRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/add-employees/sap': {
      id: '/auth/register/add-employees/sap'
      path: '/register/add-employees/sap'
      fullPath: '/auth/register/add-employees/sap'
      preLoaderRoute: typeof AuthRegisterAddEmployeesSapRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/add-employees/success': {
      id: '/auth/register/add-employees/success'
      path: '/register/add-employees/success'
      fullPath: '/auth/register/add-employees/success'
      preLoaderRoute: typeof AuthRegisterAddEmployeesSuccessRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/add-employees/upload': {
      id: '/auth/register/add-employees/upload'
      path: '/register/add-employees/upload'
      fullPath: '/auth/register/add-employees/upload'
      preLoaderRoute: typeof AuthRegisterAddEmployeesUploadRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/code/': {
      id: '/auth/register/code/'
      path: '/register/code'
      fullPath: '/auth/register/code/'
      preLoaderRoute: typeof AuthRegisterCodeIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register/code/success': {
      id: '/auth/register/code/success'
      path: '/register/code/success'
      fullPath: '/auth/register/code/success'
      preLoaderRoute: typeof AuthRegisterCodeSuccessRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/clients/$clientId/dashboard/': {
      id: '/clients/$clientId/dashboard/'
      path: '/'
      fullPath: '/clients/$clientId/dashboard/'
      preLoaderRoute: typeof ClientsClientIdDashboardIndexRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/employee-list': {
      id: '/clients/$clientId/dashboard/employee-list'
      path: '/employee-list'
      fullPath: '/clients/$clientId/dashboard/employee-list'
      preLoaderRoute: typeof ClientsClientIdDashboardEmployeeListRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/insights': {
      id: '/clients/$clientId/dashboard/insights'
      path: '/insights'
      fullPath: '/clients/$clientId/dashboard/insights'
      preLoaderRoute: typeof ClientsClientIdDashboardInsightsRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/measure-center': {
      id: '/clients/$clientId/dashboard/measure-center'
      path: '/measure-center'
      fullPath: '/clients/$clientId/dashboard/measure-center'
      preLoaderRoute: typeof ClientsClientIdDashboardMeasureCenterRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/precautionary-index': {
      id: '/clients/$clientId/dashboard/precautionary-index'
      path: '/precautionary-index'
      fullPath: '/clients/$clientId/dashboard/precautionary-index'
      preLoaderRoute: typeof ClientsClientIdDashboardPrecautionaryIndexRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/risk-center': {
      id: '/clients/$clientId/dashboard/risk-center'
      path: '/risk-center'
      fullPath: '/clients/$clientId/dashboard/risk-center'
      preLoaderRoute: typeof ClientsClientIdDashboardRiskCenterRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/settings': {
      id: '/clients/$clientId/dashboard/settings'
      path: '/settings'
      fullPath: '/clients/$clientId/dashboard/settings'
      preLoaderRoute: typeof ClientsClientIdDashboardSettingsRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/employee/$id/dearest/': {
      id: '/employee/$id/dearest/'
      path: '/dearest'
      fullPath: '/employee/$id/dearest/'
      preLoaderRoute: typeof EmployeeIdDearestIndexRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/employee/$id/dearest/sessions': {
      id: '/employee/$id/dearest/sessions'
      path: '/dearest/sessions'
      fullPath: '/employee/$id/dearest/sessions'
      preLoaderRoute: typeof EmployeeIdDearestSessionsRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/clients/$clientId/dashboard/dearest/': {
      id: '/clients/$clientId/dashboard/dearest/'
      path: '/dearest'
      fullPath: '/clients/$clientId/dashboard/dearest/'
      preLoaderRoute: typeof ClientsClientIdDashboardDearestIndexRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/dearest/coaches': {
      id: '/clients/$clientId/dashboard/dearest/coaches'
      path: '/dearest/coaches'
      fullPath: '/clients/$clientId/dashboard/dearest/coaches'
      preLoaderRoute: typeof ClientsClientIdDashboardDearestCoachesRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/dearest/sessions': {
      id: '/clients/$clientId/dashboard/dearest/sessions'
      path: '/dearest/sessions'
      fullPath: '/clients/$clientId/dashboard/dearest/sessions'
      preLoaderRoute: typeof ClientsClientIdDashboardDearestSessionsRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/dearest/share': {
      id: '/clients/$clientId/dashboard/dearest/share'
      path: '/dearest/share'
      fullPath: '/clients/$clientId/dashboard/dearest/share'
      preLoaderRoute: typeof ClientsClientIdDashboardDearestShareRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/documents/': {
      id: '/clients/$clientId/dashboard/documents/'
      path: '/documents'
      fullPath: '/clients/$clientId/dashboard/documents/'
      preLoaderRoute: typeof ClientsClientIdDashboardDocumentsIndexRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/documents/$documentId': {
      id: '/clients/$clientId/dashboard/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/clients/$clientId/dashboard/documents/$documentId'
      preLoaderRoute: typeof ClientsClientIdDashboardDocumentsDocumentIdRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/online-courses/': {
      id: '/clients/$clientId/dashboard/online-courses/'
      path: '/online-courses'
      fullPath: '/clients/$clientId/dashboard/online-courses/'
      preLoaderRoute: typeof ClientsClientIdDashboardOnlineCoursesIndexRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/online-courses/$courseId': {
      id: '/clients/$clientId/dashboard/online-courses/$courseId'
      path: '/online-courses/$courseId'
      fullPath: '/clients/$clientId/dashboard/online-courses/$courseId'
      preLoaderRoute: typeof ClientsClientIdDashboardOnlineCoursesCourseIdRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/employee/$id/dearest/book/': {
      id: '/employee/$id/dearest/book/'
      path: '/dearest/book'
      fullPath: '/employee/$id/dearest/book/'
      preLoaderRoute: typeof EmployeeIdDearestBookIndexRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/employee/$id/dearest/book/external-confirm': {
      id: '/employee/$id/dearest/book/external-confirm'
      path: '/dearest/book/external-confirm'
      fullPath: '/employee/$id/dearest/book/external-confirm'
      preLoaderRoute: typeof EmployeeIdDearestBookExternalConfirmRouteImport
      parentRoute: typeof EmployeeIdRouteRoute
    }
    '/clients/$clientId/dashboard/dearest/book/': {
      id: '/clients/$clientId/dashboard/dearest/book/'
      path: '/dearest/book'
      fullPath: '/clients/$clientId/dashboard/dearest/book/'
      preLoaderRoute: typeof ClientsClientIdDashboardDearestBookIndexRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
    '/clients/$clientId/dashboard/dearest/book/external-confirm': {
      id: '/clients/$clientId/dashboard/dearest/book/external-confirm'
      path: '/dearest/book/external-confirm'
      fullPath: '/clients/$clientId/dashboard/dearest/book/external-confirm'
      preLoaderRoute: typeof ClientsClientIdDashboardDearestBookExternalConfirmRouteImport
      parentRoute: typeof ClientsClientIdDashboardRouteRoute
    }
  }
}

interface AdminIdRouteRouteChildren {
  AdminIdHeldPairsRoute: typeof AdminIdHeldPairsRoute
  AdminIdSettingsRoute: typeof AdminIdSettingsRoute
  AdminIdIndexRoute: typeof AdminIdIndexRoute
}

const AdminIdRouteRouteChildren: AdminIdRouteRouteChildren = {
  AdminIdHeldPairsRoute: AdminIdHeldPairsRoute,
  AdminIdSettingsRoute: AdminIdSettingsRoute,
  AdminIdIndexRoute: AdminIdIndexRoute,
}

const AdminIdRouteRouteWithChildren = AdminIdRouteRoute._addFileChildren(
  AdminIdRouteRouteChildren,
)

interface AdminAddClientClientIdRouteRouteChildren {
  AdminAddClientClientIdCompanyInformationRoute: typeof AdminAddClientClientIdCompanyInformationRoute
  AdminAddClientClientIdContractObligationsRoute: typeof AdminAddClientClientIdContractObligationsRoute
  AdminAddClientClientIdLicensesRoute: typeof AdminAddClientClientIdLicensesRoute
  AdminAddClientClientIdLocationsRoute: typeof AdminAddClientClientIdLocationsRoute
  AdminAddClientClientIdOnlineCoursesAndDocumentsRoute: typeof AdminAddClientClientIdOnlineCoursesAndDocumentsRoute
  AdminAddClientClientIdRiskCenterRoute: typeof AdminAddClientClientIdRiskCenterRoute
  AdminAddClientClientIdSuccessRoute: typeof AdminAddClientClientIdSuccessRoute
}

const AdminAddClientClientIdRouteRouteChildren: AdminAddClientClientIdRouteRouteChildren =
  {
    AdminAddClientClientIdCompanyInformationRoute:
      AdminAddClientClientIdCompanyInformationRoute,
    AdminAddClientClientIdContractObligationsRoute:
      AdminAddClientClientIdContractObligationsRoute,
    AdminAddClientClientIdLicensesRoute: AdminAddClientClientIdLicensesRoute,
    AdminAddClientClientIdLocationsRoute: AdminAddClientClientIdLocationsRoute,
    AdminAddClientClientIdOnlineCoursesAndDocumentsRoute:
      AdminAddClientClientIdOnlineCoursesAndDocumentsRoute,
    AdminAddClientClientIdRiskCenterRoute:
      AdminAddClientClientIdRiskCenterRoute,
    AdminAddClientClientIdSuccessRoute: AdminAddClientClientIdSuccessRoute,
  }

const AdminAddClientClientIdRouteRouteWithChildren =
  AdminAddClientClientIdRouteRoute._addFileChildren(
    AdminAddClientClientIdRouteRouteChildren,
  )

interface AdminRouteRouteChildren {
  AdminIdRouteRoute: typeof AdminIdRouteRouteWithChildren
  AdminAddClientClientIdRouteRoute: typeof AdminAddClientClientIdRouteRouteWithChildren
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIdRouteRoute: AdminIdRouteRouteWithChildren,
  AdminAddClientClientIdRouteRoute:
    AdminAddClientClientIdRouteRouteWithChildren,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthConfirmPrivateEmailRoute: typeof AuthConfirmPrivateEmailRoute
  AuthConfirmWorkEmailRoute: typeof AuthConfirmWorkEmailRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRefreshRoute: typeof AuthRefreshRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
  AuthForgotPasswordSetRoute: typeof AuthForgotPasswordSetRoute
  AuthForgotPasswordSuccessRoute: typeof AuthForgotPasswordSuccessRoute
  AuthRegisterDearestRoute: typeof AuthRegisterDearestRoute
  AuthRegisterInviteRoute: typeof AuthRegisterInviteRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthRegisterIndexRoute: typeof AuthRegisterIndexRoute
  AuthRegisterAddEmployeesErrorRoute: typeof AuthRegisterAddEmployeesErrorRoute
  AuthRegisterAddEmployeesPersonioRoute: typeof AuthRegisterAddEmployeesPersonioRoute
  AuthRegisterAddEmployeesSapRoute: typeof AuthRegisterAddEmployeesSapRoute
  AuthRegisterAddEmployeesSuccessRoute: typeof AuthRegisterAddEmployeesSuccessRoute
  AuthRegisterAddEmployeesUploadRoute: typeof AuthRegisterAddEmployeesUploadRoute
  AuthRegisterCodeSuccessRoute: typeof AuthRegisterCodeSuccessRoute
  AuthRegisterAddEmployeesIndexRoute: typeof AuthRegisterAddEmployeesIndexRoute
  AuthRegisterCodeIndexRoute: typeof AuthRegisterCodeIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthConfirmPrivateEmailRoute: AuthConfirmPrivateEmailRoute,
  AuthConfirmWorkEmailRoute: AuthConfirmWorkEmailRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRefreshRoute: AuthRefreshRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  AuthForgotPasswordSetRoute: AuthForgotPasswordSetRoute,
  AuthForgotPasswordSuccessRoute: AuthForgotPasswordSuccessRoute,
  AuthRegisterDearestRoute: AuthRegisterDearestRoute,
  AuthRegisterInviteRoute: AuthRegisterInviteRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthRegisterIndexRoute: AuthRegisterIndexRoute,
  AuthRegisterAddEmployeesErrorRoute: AuthRegisterAddEmployeesErrorRoute,
  AuthRegisterAddEmployeesPersonioRoute: AuthRegisterAddEmployeesPersonioRoute,
  AuthRegisterAddEmployeesSapRoute: AuthRegisterAddEmployeesSapRoute,
  AuthRegisterAddEmployeesSuccessRoute: AuthRegisterAddEmployeesSuccessRoute,
  AuthRegisterAddEmployeesUploadRoute: AuthRegisterAddEmployeesUploadRoute,
  AuthRegisterCodeSuccessRoute: AuthRegisterCodeSuccessRoute,
  AuthRegisterAddEmployeesIndexRoute: AuthRegisterAddEmployeesIndexRoute,
  AuthRegisterCodeIndexRoute: AuthRegisterCodeIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface InspectionsIdRouteRouteChildren {
  InspectionsIdQuestionsRoute: typeof InspectionsIdQuestionsRoute
  InspectionsIdSummaryRoute: typeof InspectionsIdSummaryRoute
}

const InspectionsIdRouteRouteChildren: InspectionsIdRouteRouteChildren = {
  InspectionsIdQuestionsRoute: InspectionsIdQuestionsRoute,
  InspectionsIdSummaryRoute: InspectionsIdSummaryRoute,
}

const InspectionsIdRouteRouteWithChildren =
  InspectionsIdRouteRoute._addFileChildren(InspectionsIdRouteRouteChildren)

interface InspectionsRouteRouteChildren {
  InspectionsIdRouteRoute: typeof InspectionsIdRouteRouteWithChildren
  InspectionsIndexRoute: typeof InspectionsIndexRoute
}

const InspectionsRouteRouteChildren: InspectionsRouteRouteChildren = {
  InspectionsIdRouteRoute: InspectionsIdRouteRouteWithChildren,
  InspectionsIndexRoute: InspectionsIndexRoute,
}

const InspectionsRouteRouteWithChildren =
  InspectionsRouteRoute._addFileChildren(InspectionsRouteRouteChildren)

interface EmployeeIdRouteRouteChildren {
  EmployeeIdDocumentsRoute: typeof EmployeeIdDocumentsRoute
  EmployeeIdOnlineCoursesRoute: typeof EmployeeIdOnlineCoursesRoute
  EmployeeIdSettingsRoute: typeof EmployeeIdSettingsRoute
  EmployeeIdIndexRoute: typeof EmployeeIdIndexRoute
  EmployeeIdDearestSessionsRoute: typeof EmployeeIdDearestSessionsRoute
  EmployeeIdDearestIndexRoute: typeof EmployeeIdDearestIndexRoute
  EmployeeIdDearestBookExternalConfirmRoute: typeof EmployeeIdDearestBookExternalConfirmRoute
  EmployeeIdDearestBookIndexRoute: typeof EmployeeIdDearestBookIndexRoute
}

const EmployeeIdRouteRouteChildren: EmployeeIdRouteRouteChildren = {
  EmployeeIdDocumentsRoute: EmployeeIdDocumentsRoute,
  EmployeeIdOnlineCoursesRoute: EmployeeIdOnlineCoursesRoute,
  EmployeeIdSettingsRoute: EmployeeIdSettingsRoute,
  EmployeeIdIndexRoute: EmployeeIdIndexRoute,
  EmployeeIdDearestSessionsRoute: EmployeeIdDearestSessionsRoute,
  EmployeeIdDearestIndexRoute: EmployeeIdDearestIndexRoute,
  EmployeeIdDearestBookExternalConfirmRoute:
    EmployeeIdDearestBookExternalConfirmRoute,
  EmployeeIdDearestBookIndexRoute: EmployeeIdDearestBookIndexRoute,
}

const EmployeeIdRouteRouteWithChildren = EmployeeIdRouteRoute._addFileChildren(
  EmployeeIdRouteRouteChildren,
)

interface ClientsClientIdDashboardRouteRouteChildren {
  ClientsClientIdDashboardEmployeeListRoute: typeof ClientsClientIdDashboardEmployeeListRoute
  ClientsClientIdDashboardInsightsRoute: typeof ClientsClientIdDashboardInsightsRoute
  ClientsClientIdDashboardMeasureCenterRoute: typeof ClientsClientIdDashboardMeasureCenterRoute
  ClientsClientIdDashboardPrecautionaryIndexRoute: typeof ClientsClientIdDashboardPrecautionaryIndexRoute
  ClientsClientIdDashboardRiskCenterRoute: typeof ClientsClientIdDashboardRiskCenterRoute
  ClientsClientIdDashboardSettingsRoute: typeof ClientsClientIdDashboardSettingsRoute
  ClientsClientIdDashboardIndexRoute: typeof ClientsClientIdDashboardIndexRoute
  ClientsClientIdDashboardDearestCoachesRoute: typeof ClientsClientIdDashboardDearestCoachesRoute
  ClientsClientIdDashboardDearestSessionsRoute: typeof ClientsClientIdDashboardDearestSessionsRoute
  ClientsClientIdDashboardDearestShareRoute: typeof ClientsClientIdDashboardDearestShareRoute
  ClientsClientIdDashboardDocumentsDocumentIdRoute: typeof ClientsClientIdDashboardDocumentsDocumentIdRoute
  ClientsClientIdDashboardOnlineCoursesCourseIdRoute: typeof ClientsClientIdDashboardOnlineCoursesCourseIdRoute
  ClientsClientIdDashboardDearestIndexRoute: typeof ClientsClientIdDashboardDearestIndexRoute
  ClientsClientIdDashboardDocumentsIndexRoute: typeof ClientsClientIdDashboardDocumentsIndexRoute
  ClientsClientIdDashboardOnlineCoursesIndexRoute: typeof ClientsClientIdDashboardOnlineCoursesIndexRoute
  ClientsClientIdDashboardDearestBookExternalConfirmRoute: typeof ClientsClientIdDashboardDearestBookExternalConfirmRoute
  ClientsClientIdDashboardDearestBookIndexRoute: typeof ClientsClientIdDashboardDearestBookIndexRoute
}

const ClientsClientIdDashboardRouteRouteChildren: ClientsClientIdDashboardRouteRouteChildren =
  {
    ClientsClientIdDashboardEmployeeListRoute:
      ClientsClientIdDashboardEmployeeListRoute,
    ClientsClientIdDashboardInsightsRoute:
      ClientsClientIdDashboardInsightsRoute,
    ClientsClientIdDashboardMeasureCenterRoute:
      ClientsClientIdDashboardMeasureCenterRoute,
    ClientsClientIdDashboardPrecautionaryIndexRoute:
      ClientsClientIdDashboardPrecautionaryIndexRoute,
    ClientsClientIdDashboardRiskCenterRoute:
      ClientsClientIdDashboardRiskCenterRoute,
    ClientsClientIdDashboardSettingsRoute:
      ClientsClientIdDashboardSettingsRoute,
    ClientsClientIdDashboardIndexRoute: ClientsClientIdDashboardIndexRoute,
    ClientsClientIdDashboardDearestCoachesRoute:
      ClientsClientIdDashboardDearestCoachesRoute,
    ClientsClientIdDashboardDearestSessionsRoute:
      ClientsClientIdDashboardDearestSessionsRoute,
    ClientsClientIdDashboardDearestShareRoute:
      ClientsClientIdDashboardDearestShareRoute,
    ClientsClientIdDashboardDocumentsDocumentIdRoute:
      ClientsClientIdDashboardDocumentsDocumentIdRoute,
    ClientsClientIdDashboardOnlineCoursesCourseIdRoute:
      ClientsClientIdDashboardOnlineCoursesCourseIdRoute,
    ClientsClientIdDashboardDearestIndexRoute:
      ClientsClientIdDashboardDearestIndexRoute,
    ClientsClientIdDashboardDocumentsIndexRoute:
      ClientsClientIdDashboardDocumentsIndexRoute,
    ClientsClientIdDashboardOnlineCoursesIndexRoute:
      ClientsClientIdDashboardOnlineCoursesIndexRoute,
    ClientsClientIdDashboardDearestBookExternalConfirmRoute:
      ClientsClientIdDashboardDearestBookExternalConfirmRoute,
    ClientsClientIdDashboardDearestBookIndexRoute:
      ClientsClientIdDashboardDearestBookIndexRoute,
  }

const ClientsClientIdDashboardRouteRouteWithChildren =
  ClientsClientIdDashboardRouteRoute._addFileChildren(
    ClientsClientIdDashboardRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  InspectionsRouteRoute: InspectionsRouteRouteWithChildren,
  EmployeeIdRouteRoute: EmployeeIdRouteRouteWithChildren,
  DashboardSplatRoute: DashboardSplatRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  ClientsClientIdDashboardRouteRoute:
    ClientsClientIdDashboardRouteRouteWithChildren,
  EmployeeUploadsUploadIdFailedRowsRoute:
    EmployeeUploadsUploadIdFailedRowsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
